import { Dispatch } from 'redux'

import notificationTypes from '../../config/notificationTypes'

import addNotification from '../../actions/notifications/addNotification'

import generateUniqueId from '../generateUniqueId'

export default (dispatch: Dispatch, message: string) => {
  dispatch(
    addNotification({
      id: generateUniqueId(),
      type: notificationTypes.success,
      message,
      isGlobal: true,
    })
  )
}
